import http from '@/http'
import Organization from '@/store/models/Organization'

const API_PATH = 'organizations/'

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  async create({ commit }, payload) {
    const params = JSON.stringify({
      organization: payload
    })
    await http.post(API_PATH, params).then(response => {
      Organization.insert({
        data: response.data.data.attributes
      })
    }).catch(error => {
      commit('setHttpError', error, { root: true })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
